module.exports = __webpack_public_path__ + "static/img/label-01.6fdc4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/label-01.png
// module id = vDJ6
// module chunks = 134